<div class="d-flex justify-content-between mb-3">
  <div>
    <h2 class="h3 mb-0">
      {{ 'dashboard.widgets.patients.title' | translate }}
    </h2>
    <div class="small text-secondary">
      <fa-icon [icon]="'circle-check'" class="text-primary"></fa-icon>
      {{ 'dashboard.widgets.patients.number-of-patients' | translate: { count: totalNumberOfPatients() } }}
    </div>
  </div>

  <button class="btn btn-primary" type="button" [routerLink]="['/patients', 'new']">
    <fa-icon [icon]="'user-plus'" class="me-1"></fa-icon>
    {{ 'dashboard.widgets.patients.add-button' | translate }}
  </button>
</div>

<lib-search-input [placeholder]="'search.placeholder'" [(searchTerm)]="searchTerms" />

@if (!isSearching()) {
  <div class="text-center text-secondary">
    <div class="icon-wrapper mb-2">
      <fa-icon [icon]="'magnifying-glass'"></fa-icon>
    </div>
    <p>{{ 'dashboard.widgets.patients.results-placeholder' | translate }}</p>
  </div>
}

@if (hasNoSearchResults()) {
  <lib-no-search-results [searchTerm]="searchTerms()" />
}

@if (isSearching() && !hasNoSearchResults()) {
  <lib-patients-table [patients]="filteredPatients()" (clickedTableRow)="navigateToPatientDetails($event)" />
}
